import { render, staticRenderFns } from "./AnimatedLogotype.vue?vue&type=template&id=7415d27f&"
import script from "./AnimatedLogotype.vue?vue&type=script&lang=js&"
export * from "./AnimatedLogotype.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedLogotype.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports